import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.object.get-prototype-of";
import "core-js/modules/es.object.set-prototype-of";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Isvg from 'react-inlinesvg';
import { DESIGN_SYSTEM } from 'constants/icons';
export var Activity =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Activity, _PureComponent);

  function Activity() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Activity);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Activity)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "handleRemoveClick", function (event) {
      event.stopPropagation();

      _this.props.onRemoveClick(_this.props.searchId);
    });

    return _this;
  }

  _createClass(Activity, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          label = _this$props.nameHighlighted,
          highlighted = _this$props.highlighted,
          searchId = _this$props.searchId,
          onClick = _this$props.onClick,
          onMouseDown = _this$props.onMouseDown,
          onMouseMove = _this$props.onMouseMove,
          role = _this$props.role,
          ariaSelected = _this$props['aria-selected'],
          id = _this$props.id;
      return React.createElement("li", {
        className: classNames('dropdown__item searchbox__activity', {
          'dropdown__item--highlighted': highlighted
        }),
        id: id,
        onClick: onClick,
        onMouseDown: onMouseDown,
        onMouseMove: onMouseMove,
        role: role,
        "aria-selected": ariaSelected
      }, React.createElement(Isvg, {
        className: "dropdown__item__icon",
        src: DESIGN_SYSTEM.lookingGlass
      }), React.createElement("div", {
        className: "dropdown__item__content"
      }, React.createElement("span", {
        className: "dropdown__item__label",
        dangerouslySetInnerHTML: {
          __html: label
        } // eslint-disable-line react/no-danger

      })), searchId && React.createElement("div", {
        className: "dropdown__item__remove",
        onClick: this.handleRemoveClick
      }, "x"));
    }
  }]);

  return Activity;
}(PureComponent);
Activity.propTypes = {
  highlighted: PropTypes.bool.isRequired,
  nameHighlighted: PropTypes.string.isRequired,
  onRemoveClick: PropTypes.func.isRequired,
  searchId: PropTypes.string,
  'aria-selected': PropTypes.bool.isRequired,
  id: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  onMouseDown: PropTypes.func.isRequired,
  onMouseMove: PropTypes.func.isRequired,
  role: PropTypes.string.isRequired
};